import React, { useEffect, useContext } from 'react';
import { GlobalContext } from '../../context/GlobalContext';
import { Link } from 'react-router-dom';
import Jumbotron from './Jumbotron';
import About from './About';
import axios from 'axios';

function LandingMain() {
    const { state, handlers, functions } = useContext(GlobalContext);
    const {
        jobData,
        setJobData,
        fetchStatus,
        setFetchStatus,
        search,
        companyList,
        setCompanyList,
        cityList,
        setCityList,
        loading,
        setLoading,
    } = state;
    const { formatSalary } = functions;
    const { handleSearch, handleReset, handleFilter } = handlers;

    useEffect(() => {
        if (fetchStatus === true) {
            setLoading(true);

            axios
                .get('https://dev-example.sanbercloud.com/api/job-vacancy')
                .then((response) => {
                    let list = response.data.data;

                    setJobData(list);

                    setCompanyList([
                        ...new Set(
                            list.map((result) => {
                                return result.company_name;
                            })
                        ),
                    ]);

                    setCityList([
                        ...new Set(
                            list.map((result) => {
                                return result.company_city;
                            })
                        ),
                    ]);

                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });

            setFetchStatus(false);
        }
    }, [
        setJobData,
        setFetchStatus,
        fetchStatus,
        setCityList,
        setCompanyList,
        setLoading,
    ]);

    return (
        <div className='flex h-fit flex-col bg-slate-100 p-6 pb-10 md:px-10'>
            <Jumbotron />

            <h2 id='about-us' className='mb-14 text-center text-2xl font-[700]'>
                Join Us
            </h2>
            <About />

            <h2 id='explore' className='mb-20 text-center text-2xl font-[700]'>
                Explore
            </h2>

            <div className='mb-10'>
                <form className='flex flex-col gap-y-5 md:flex-row md:flex-wrap md:gap-x-5'>
                    <div className='w-11/12 md:w-1/3'>
                        <label
                            htmlFor='search'
                            className='sr-only mb-2 text-sm font-medium text-gray-900 dark:text-gray-300'
                        >
                            Search
                        </label>
                        <div className='relative'>
                            <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
                                <svg
                                    aria-hidden='true'
                                    className='h-5 w-5 text-gray-500 dark:text-gray-400'
                                    fill='none'
                                    stroke='currentColor'
                                    viewBox='0 0 24 24'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth='2'
                                        d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                                    ></path>
                                </svg>
                            </div>
                            <input
                                onChange={handleSearch}
                                value={search}
                                type='search'
                                id='search'
                                className='block w-full rounded-lg border border-gray-300 bg-gray-50 p-4 pl-10 text-sm text-gray-900 focus:border-sky-500 focus:ring-sky-500'
                                placeholder='Developer...'
                            />
                            <button
                                onClick={handleReset}
                                type='submit'
                                className='absolute right-2.5 bottom-2.5 rounded-lg bg-sky-500 px-4 py-2 text-sm font-medium text-white hover:bg-sky-600 focus:outline-none focus:ring-sky-300'
                            >
                                Reset
                            </button>
                        </div>
                    </div>
                    <div className='flex flex-wrap gap-5 md:w-7/12'>
                        <select
                            onChange={handleFilter}
                            id='company'
                            name='company'
                            className='block w-2/5 rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-sky-500 focus:ring-sky-500'
                        >
                            <option value={''}>All Companies</option>
                            {companyList !== null &&
                                companyList.map((company, id) => {
                                    return (
                                        <option key={id} value={company}>
                                            {company}
                                        </option>
                                    );
                                })}
                        </select>
                        <select
                            onChange={handleFilter}
                            id='city'
                            name='city'
                            className='block w-1/3 rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-sky-500 focus:ring-sky-500 md:w-1/4'
                        >
                            <option value={''}>All City</option>
                            {cityList !== null &&
                                cityList.map((city, id) => {
                                    return (
                                        <option key={id} value={city}>
                                            {city}
                                        </option>
                                    );
                                })}
                        </select>
                        <select
                            onChange={handleFilter}
                            id='status'
                            name='status'
                            className='block w-1/3 rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-sky-500 focus:ring-sky-500 md:w-1/4'
                        >
                            <option value={''}>All Status</option>
                            <option value={1}>Open</option>
                            <option value={0}>Closed</option>
                        </select>
                    </div>
                </form>
            </div>

            <div className=' flex justify-center'>
                <div className='flex w-full flex-wrap justify-center gap-5'>
                    {jobData !== null &&
                        jobData.map((list) => {
                            const {
                                id,
                                company_image_url,
                                company_city,
                                company_name,
                                title,
                                job_type,
                                job_status,
                                salary_min,
                                salary_max,
                            } = list;

                            return (
                                <Link key={id} to={`/job-detail/${id}`}>
                                    <div className='flex h-52  w-96 justify-between gap-x-4 rounded-xl bg-white p-4 transition-all duration-300 hover:scale-[1.02] hover:cursor-pointer hover:shadow-lg'>
                                        <div className='flex items-center justify-center p-2'>
                                            {company_image_url === null ? (
                                                <img
                                                    className='h-24 w-28 rounded-[50%]'
                                                    src={
                                                        'https://aliffs.utsource.net/public/nopic.jpg?x-oss-process=style/other'
                                                    }
                                                    alt=''
                                                />
                                            ) : (
                                                <img
                                                    className='h-24 w-28 rounded-[50%]'
                                                    src={company_image_url}
                                                    alt=''
                                                />
                                            )}
                                        </div>

                                        <div className='flex w-2/3 flex-col justify-center'>
                                            <h4 className='w-fit text-sm text-slate-400'>
                                                {company_name}
                                            </h4>

                                            <h3 className='mb-2 w-fit text-xl font-bold'>
                                                {title}
                                            </h3>

                                            <div className='flex items-center gap-x-2 text-xs'>
                                                <svg
                                                    className='h-4 w-4'
                                                    fill='none'
                                                    stroke='currentColor'
                                                    viewBox='0 0 24 24'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        strokeWidth={1}
                                                        d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'
                                                    />
                                                    <path
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        strokeWidth={1}
                                                        d='M15 11a3 3 0 11-6 0 3 3 0 016 0z'
                                                    />
                                                </svg>
                                                <p>{company_city}</p>
                                            </div>

                                            <div className='mt-1 flex items-center gap-x-2 text-xs'>
                                                <svg
                                                    className='h-4 w-4'
                                                    fill='none'
                                                    stroke='currentColor'
                                                    viewBox='0 0 24 24'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        strokeWidth={1}
                                                        d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                                                    />
                                                </svg>
                                                <p>{job_type}</p>
                                            </div>

                                            <div className='mt-1 flex items-center gap-x-2 text-xs'>
                                                <svg
                                                    className='h-4 w-4'
                                                    fill='none'
                                                    stroke='currentColor'
                                                    viewBox='0 0 24 24'
                                                    xmlns='http://www.w3.org/2000/svg'
                                                >
                                                    <path
                                                        strokeLinecap='round'
                                                        strokeLinejoin='round'
                                                        strokeWidth={1}
                                                        d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                                                    />
                                                </svg>
                                                <p>
                                                    {formatSalary(salary_min)} -{' '}
                                                    {formatSalary(salary_max)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className='flex h-full flex-row items-baseline justify-end'>
                                            <div
                                                className={`${
                                                    job_status === 1
                                                        ? 'bg-green-400'
                                                        : 'bg-rose-500'
                                                } h-2 w-2 rounded-full`}
                                            ></div>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}

export default LandingMain;
